import React, {useContext, useState} from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useHistory} from "react-router";
import {signIn} from "@api/auth";
import {setToken} from "@api/token";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {validation} from "@services/validation"
import { renderForm } from "@components/Form/renderForm";
import {RoleContext} from "@hoc/role";
import {getRole} from "@api/token";


export const SignIn = () => {
    const onCallback = (e) => {
        formValues.forEach((column) => {
            if (column.name === e.target.name) {
                column.value = e.target.value;
                column.error = '';
            }
        })
        setFormValues([...formValues]);
    }
    const data = [
        {name: 'login', headerName: 'login', value: '', error: '', type: 'string', onCallback},
        {name: 'password', headerName: 'password', value: '', error: '', type: 'string', onCallback},
    ]

        // eslint-disable-next-line no-unused-vars
        const {loading, setLoading} = useContext(LoadingContext);
        // eslint-disable-next-line no-unused-vars
        const {errorMessage, setErrorMessage} = useContext(MessageContext);
        const {setRole} = useContext(RoleContext);
        const [formValues, setFormValues] = useState(data)
        const history = useHistory();


        const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);

            try {
                const data = new FormData(event.currentTarget);
                const email = data.get("login");
                const password = data.get("password");
                const token = await (signIn(email, password));
                await setToken(token);
                setRole(getRole())
                return history.push('/benefits');
            } catch (error) {
                validation(error, formValues, (columns) => {
                    return setFormValues([...columns]);
                })
            }
            setLoading(false);
        };

        return (
            <>

                <Box
                    sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        sx={{mt: 1}}
                    >
                        {formValues.map((data, key) => {
                        return renderForm(data, key);
                    })}
                        {/* <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        /> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                        >
                            Sign In
                        </Button>
                    </Box>
                </Box>
            </>
        );
    }
;
